<template>
  <div>
    <!-- 조직 등록 및 수정 폼 -->
    <b-card title="조직 등록 및 연합 관리">
      <b-form @submit.prevent="onSubmit">
        <!-- 조직명 입력 -->
        <b-form-group label="조직명1111" label-for="organizationName-input" description="조직의 이름을 입력하세요.">
          <b-form-input
            id="organizationName-input"
            v-model="organization.organizationName"
            required
          ></b-form-input>
        </b-form-group>

        <!-- 조직 Prefix 입력 -->
        <b-form-group label="조직 Prefix" label-for="organizationPrefix-input" description="조직의 Prefix를 입력하세요.">
          <b-form-input
            id="organizationPrefix-input"
            v-model="organization.organizationPrefix"
          ></b-form-input>
        </b-form-group>

        <!-- Prefix 유형 선택 -->
        <b-form-group label="Prefix 유형" label-for="prefixType-select">
          <b-form-select
            id="prefixType-select"
            v-model="organization.prefixType"
            :options="barcodeTypeOptions"
          ></b-form-select>
        </b-form-group>

        <!-- 등록 버튼 -->
        <b-button type="submit" variant="primary">조직 등록</b-button>
      </b-form>
    </b-card>

    <!-- 연합 등록 폼 -->
    <b-card title="연합 등록" class="mt-3">
      <b-form @submit.prevent="addAlliance">
        <!-- 연합명 입력 -->
        <b-form-group label="연합명" label-for="allianceName-input" description="연합의 이름을 입력하세요.">
          <b-form-input
            id="allianceName-input"
            v-model="newAlliance.allianceName"
            required
          ></b-form-input>
        </b-form-group>

        <!-- 연합 대상 조직 선택 -->
        <b-form-group label="조직 선택" label-for="company-select">
          <b-form-select
            id="company-select"
            v-model="newAlliance.company"
            :options="organizationOptions"
          ></b-form-select>
        </b-form-group>
        
        <!-- 추가 버튼 -->
        <b-button type="submit" variant="secondary">연합 추가</b-button>
      </b-form>
    </b-card>

    <!-- 연합 목록 테이블 -->
    <b-card title="연합 목록" class="mt-3">
      <b-table
        :items="organization.alliances"
        :fields="allianceFields"
        striped
        bordered
        hover
      >
        <template #cell(actions)="data">
          <b-button size="sm" variant="danger" @click="deleteAlliance(data.item)">삭제</b-button>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      organization: {
        organizationName: '',
        organizationPrefix: '',
        prefixType: null,
        alliances: [] // 조직에 연결된 연합 목록
      },
      barcodeTypeOptions: [
        { value: null, text: '선택해 주세요' },
        { value: 'GS1', text: 'GS1' },
        { value: 'KFT', text: 'KFT' }
      ],
      organizationOptions: [
        { value: null, text: '선택해 주세요' },
        // 실제 조직 데이터를 불러와서 옵션으로 설정해야 함
      ],
      newAlliance: {
        allianceName: '',
        company: null
      },
      allianceFields: [
        { key: 'allianceName', label: '이름' },
        { key: 'company.organizationName', label: '조직' },
        { key: 'actions', label: '조작' }
      ]
    };
  },
  methods: {
    onSubmit() {
      // 조직 등록 로직
      console.log('등록된 조직 정보:', this.organization);
      // 서버로 데이터 전송 혹은 저장 로직
    },
    addAlliance() {
      // 새로운 연합을 추가하는 로직
      console.log('새로운 연합:', this.newAlliance);
      this.organization.alliances.push({ ...this.newAlliance });
      this.resetNewAllianceForm();
    },
    deleteAlliance(alliance) {
      // 연합 삭제 로직
      console.log('삭제할 연합:', alliance);
      this.organization.alliances = this.organization.alliances.filter(a => a !== alliance);
    },
    resetNewAllianceForm() {
      this.newAlliance = {
        allianceName: '',
        company: null
      };
    }
  },
  created() {
    // 초기 로드시 조직 데이터 및 기존 연합 목록을 가져오는 로직을 추가
  }
};
</script>

<style scoped>
/* 필요에 따라 스타일링 추가 */
</style>
